const selectState = val => (
  (dispatch) => {
    dispatch(({
      type: 'SELECT_EFILE_STATE',
      selectedState: val,
    }));
  }
);

export default selectState;



// WEBPACK FOOTER //
// ./src-react/IowaBENInput/IowaBENInputActions.jsx